import app from '../../main'
const qs = require('qs')

export default {
    namespaced: true,
    state: {
        garnitures: [],
        mobileGarnitures: [],
        pagination: {
            page: 1,
            totalPages: 1,
            totalProducts: 0,
            pageSize: 16
        },
        itemsInSet: [],
        errors: {
            getGarnitures: {},
            getItemsInSet: {}
        }
    },
    mutations: {
        SET_GARNITURES(state, payload) {
            state.garnitures = payload
        },
        CLEAR_GARNITURES(state) {
            state.garnitures = []
            state.mobileGarnitures = []
            state.pagination = {
                page: 1,
                totalPages: 1,
                totalProducts: 0,
                pageSize: 16
            }
        },
        SET_MOBILE_GARNITURES(state, payload) {
            if (state.pagination.page == 1) {
                state.mobileGarnitures = payload
            } else {
                state.mobileGarnitures = [...state.mobileGarnitures, ...payload]
            }
        },
        SET_PAGINATION(state, payload) {
            state.pagination[payload.key] = payload.val
        },
        SET_ITEMS_IN_SET(state, payload) {
            state.itemsInSet = payload
        },
        SET_ERRORS(state, error) {
            state.errors[error.key] = error.val
        }
    },
    actions: {
        setPagination({ commit }, pagination) {
            for (const [key, value] of Object.entries(pagination)) {
                commit('SET_PAGINATION', {
                    key,
                    val: value
                })
            }
        },
        clearGarnitures({ commit, state }) {
            commit('CLEAR_GARNITURES')
        },
        async getGarnitures({ commit, state, dispatch }, data) {
            commit('SET_ERRORS', {
                key: 'getGarnitures',
                val: {}
            })

            const url = '/public/sets'

            try {
                const resp = await this.$axios.get(url, {
                    params: {
                        ...data,
                        items: state.pagination.pageSize
                    },
                    paramsSerializer: function(params) {
                        return qs.stringify(params, { arrayFormat: 'brackets' })
                    }
                })
                app.$Progress.finish()

                commit('SET_GARNITURES', resp.data)

                dispatch('setPagination', {
                    page: parseInt(resp.headers['page']),
                    totalPages: parseInt(resp.headers['total-pages']),
                    totalProducts: parseInt(resp.headers['total-records']),
                    pageSize: parseInt(resp.headers['page-size'])
                })

                if (
                    (data && data.isMobilePagination) ||
                    state.pagination.page == 1
                ) {
                    commit('SET_MOBILE_GARNITURES', resp.data)
                }
            } catch (e) {
                app.$Progress.fail()
                if (e.response && e.response.data) {
                    console.log(e.response.data)
                    commit('SET_ERRORS', {
                        key: 'getGarnitures',
                        val: e.response.data
                    })
                } else {
                    console.log('Ошибка ' + e.message)
                    commit('SET_ERRORS', {
                        key: 'getGarnitures',
                        val: { error: 'Ошибка' }
                    })
                }
            }
        },
        async getItemsInSet({ commit }, data) {
            commit('SET_ERRORS', {
                key: 'getItemsInSet',
                val: {}
            })

            const url = `/public/item-set?SetID=${data.setID}`

            try {
                const resp = await this.$axios.get(url, { params: data })
                commit('SET_ITEMS_IN_SET', resp.data)
            } catch (e) {
                if (e.response && e.response.data) {
                    console.log(e.response.data)
                    commit('SET_ERRORS', {
                        key: 'getItemsInSet',
                        val: e.response.data
                    })
                } else {
                    console.log('Ошибка ' + e.message)
                    commit('SET_ERRORS', {
                        key: 'getItemsInSet',
                        val: { error: 'Ошибка' }
                    })
                }
            }
        }
    }
}
